import script from "./WorkspaceConfigurationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceConfigurationModal.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceConfigurationModal.vue?vue&type=style&index=0&id=48bd7e01&lang=scss&scoped=true"
import "./WorkspaceConfigurationModal.vue?vue&type=style&index=1&id=48bd7e01&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48bd7e01"]])

export default __exports__